'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; //
//
//
//
//
//
//
//
//
//

var _type = require('./type');

var _type2 = _interopRequireDefault(_type);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var dom = weex.requireModule('dom');

exports.default = {
  props: {
    name: {
      default: 'success',
      type: String
    },
    size: {
      default: 'small',
      type: String
    },
    iconStyle: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      Icon: _type2.default
    };
  },
  beforeCreate: function beforeCreate() {
    var url = weex.config.bundleUrl;
    if (url.indexOf('?') > 0) {
      url = url.substring(0, url.indexOf('?'));
    }
    url = url.split('/').slice(0, -2).join('/');
    if (url.indexOf('http') !== 0 && url.indexOf('file') !== 0) {
      if (url.indexOf('/') === 0) {
        url = url.substring(url.indexOf('/') + 1);
      }
      url = 'local://' + (url === '' ? '' : '/') + url;
    }
    // console.log("icon url", url);
    var ICON_ONLINE = 'https://at.alicdn.com/t/font_1278468_jszcyyrozyd.ttf';
    dom && dom.addRule && dom.addRule('fontFace', {
      fontFamily: 'iconfont',
      src: 'url(\'https://at.alicdn.com/t/font_1325601_4bb1pxvuqrc.ttf\')'
    });
    // dom.addRule('fontFace', {
    //   fontFamily: 'iconfont',
    //   src: 'url(\'' + url + '/assets/font/font_1278468_f69rlcvt2nb.ttf\')'
    // });
  },

  computed: {
    mergeStyle: function mergeStyle() {
      var iconStyle = this.iconStyle,
          size = this.size;

      var fontSize = '48px';
      switch (size) {
        case 'xs':
          fontSize = '24px';
          break;
        case 'small':
          fontSize = '48px';
          break;
        case 'medium':
          fontSize = '72px';
          break;
        case 'big':
          fontSize = '128px';
          break;
        default:
          fontSize = '48px';
      }
      return _extends({
        fontFamily: 'iconfont',
        fontSize: fontSize
      }, iconStyle);
    }
  },
  methods: {
    itemClicked: function itemClicked(name) {
      this.$emit('dofIconClicked', {
        name: name
      });
    }
  }
};


//////////////////
// WEBPACK FOOTER
// ./~/weex-vue-loader/lib/script-loader.js!./~/babel-loader/lib!./~/weex-vue-loader/lib/selector.js?type=script&index=0!./packages/dof-icon/index.vue
// module id = 335
// module chunks = 0 1